import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const BankDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Bank Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <ul className="">
            <li>
              <h4>Bank Name</h4>
              <h6>{employee?.bankName}</h6>
            </li>
            <li>
              <h4>Account Number</h4>
              <h6>{employee?.accountNo}</h6>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

BankDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default BankDetails;
